import { ReactNode } from 'react';
import BaseButton from './BaseButton';

interface EmptyStateProps {
  icon?: ReactNode;
  title?: string;
  description?: string;
  actionButton?: {
    label: string;
    onClick: () => void;
  };
  className?: string;
}

const EmptyState = ({
  icon,
  title,
  description,
  actionButton,
  className = ''
}: EmptyStateProps) => {
  return (
    <div
      className={`flex flex-col items-center justify-center ~gap-3/5 ~py-5/10 ~px-4/6 text-center ${className}`}>
      {icon && icon}
      <h3 className='~text-base/xl font-semibold text-secondary-dark-700 dark:text-secondary-600'>
        {title}
      </h3>
      {description && (
        <p className='~text-sm/base text-secondary-dark-800 dark:text-secondary-900 max-w-md'>
          {description}
        </p>
      )}
      {actionButton && (
        <BaseButton title={actionButton.label} onClick={actionButton.onClick} />
      )}
    </div>
  );
};

export default EmptyState;
